import { BaseContext } from "../../../utils/basecontext";
import { HttpClient } from "../../../utils/httpclient/httpclient";
import { POST } from '../api';
import { SixdeeCRBTAPI } from "../sixdeecrbtapi";
import { DefaultToneRequest } from "./defaulttonerequest";
import { LanguageConst } from 'src/com/sixdee/crbtportal/utils/resources/languageconst';

export class DefaultToneAPI extends SixdeeCRBTAPI<DefaultToneRequest>
{
    constructor(httpClient:HttpClient, appContext: BaseContext){
        super(httpClient, appContext);
    }

    getHttpMethod(){
        return POST;
    }

    getAPIURL(): string
    { 
        return "set-default-tone";
    }
    
    getRequestData()
    {
        return "msisdn=" + this.getRequest().getDefaultToneRequest().getAPartyMsisdn() +"&"+
        "clientTxnId=11092020 "+"&"+
        "toneId="+ this.getRequest().getDefaultToneRequest().getToneId() +"&"+
        "priority="+ this.getRequest().getDefaultToneRequest().getPriority() +"&"+
        "channelId="+ this.getRequest().getDefaultToneRequest().getChannelId() +"&"+
        "serviceId="+ this.getRequest().getDefaultToneRequest().getServiceId() +"&"+
        "packName="+ this.getRequest().getDefaultToneRequest().getPackName() +"&"+
        "language="+ (this.getRequest().getDefaultToneRequest().getLanguage() === LanguageConst.ENGLISH ? "1": "2");
            
            

               
    }
}





// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/defaulttone/defaulttoneapi.tsx